import { createFileRoute } from '@tanstack/react-router'
import RelatoriosOportunidadesPage from '@/pages/relatorios/relatorios-oportunidades-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/relatorios/oportunidades'
)({
  component: function RelatoriosOportunidadesRoute() {
    const { dashboardId } = Route.useParams()
    
    return (
      <RequireModule module={MODULES.RELATORIOS} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.VIEW_REPORTS}>
          <RelatoriosOportunidadesPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
